module.exports = __webpack_public_path__ + "img/infoBlue.71956683.svg";